const bufferLogo = `

██████╗ ██╗   ██╗███████╗███████╗███████╗██████╗ 
██╔══██╗██║   ██║██╔════╝██╔════╝██╔════╝██╔══██╗
██████╔╝██║   ██║█████╗  █████╗  █████╗  ██████╔╝
██╔══██╗██║   ██║██╔══╝  ██╔══╝  ██╔══╝  ██╔══██╗
██████╔╝╚██████╔╝██║     ██║     ███████╗██║  ██║
╚═════╝  ╚═════╝ ╚═╝     ╚═╝     ╚══════╝╚═╝  ╚═╝


`
const introSimple = `

+--------+
| BUFFER |
+--------+

`

const showBufferLogo = () => {
  // Styles
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const fontFamily =
    'Stolzl, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
  const fontColor = isDark ? '#FFF' : '#213130'

  // Log
  !isSafari && console.log(bufferLogo)
  console.log(
    '%c🚀 WE ARE HIRING! 🚀',
    `background: #D4C1FF; color: #213130; padding: 2px; font-size: 14px; font-weight: bold; border-radius: 5px; font-family: ${fontFamily};`,
  )
  console.log(
    '%cHey developer! 👋🏼 If you are reading this, you might be a great fit for our team!\n\nSee open roles at Buffer: https://www.buffer.com/journey\n\n💡 Mention "console.log" in your application for bonus points!',
    `color: ${fontColor}; font-size: 12px; font-family: ${fontFamily};`,
  )
}

window.addEventListener('load', () => {
  showBufferLogo()
})

window
  .matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', (e) => {
    showBufferLogo()
  })
